/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { LeaderboardEntry } from '../types/leaderboard';

export const LEADERBOARD_DATA: LeaderboardEntry[] = [
    { rank: 1, walletAddress: '7xKX...9jL2', totalVolume: 2500000, tokensLaunched: 15, points: 12500, badges: ['Whale', 'OG'], change24h: 0 },
    { rank: 2, walletAddress: 'H8s...k2La', totalVolume: 1800000, tokensLaunched: 8, points: 9200, badges: ['Diamond Hands'], change24h: 1 },
    { rank: 3, walletAddress: '0x82...3b1a', totalVolume: 1200000, tokensLaunched: 22, points: 8800, badges: ['Creator'], change24h: -1 },
    { rank: 4, walletAddress: '9pL...m1K', totalVolume: 950000, tokensLaunched: 5, points: 6500, badges: [], change24h: 2 },
    { rank: 5, walletAddress: 'Dez...263', totalVolume: 800000, tokensLaunched: 3, points: 5100, badges: ['Early'], change24h: 0 },
    { rank: 6, walletAddress: '4aB...cDeF', totalVolume: 750000, tokensLaunched: 1, points: 4800, badges: [], change24h: 3 },
    { rank: 7, walletAddress: 'G9h...iJkL', totalVolume: 680000, tokensLaunched: 18, points: 4500, badges: ['Creator'], change24h: -2 },
    { rank: 8, walletAddress: '0x12...5678', totalVolume: 610000, tokensLaunched: 2, points: 4100, badges: [], change24h: 0 },
    { rank: 9, walletAddress: 'MnP...qRsT', totalVolume: 550000, tokensLaunched: 0, points: 3800, badges: ['Sniper'], change24h: 5 },
    { rank: 10, walletAddress: 'uVw...XyZ', totalVolume: 510000, tokensLaunched: 7, points: 3500, badges: [], change24h: -1 },
];